<template>
  <ol v-if="items" class="breadcrumb">
    <font-awesome-icon v-if="!items.length" spin size="lg" icon="circle-notch" class="text-moremuted" style="margin: 1.2px 0"/>

    <template v-else>
      <li class="breadcrumb-item">
        <router-link :to="$config.homeUrl || '/'">{{ $t('nav.home') }}</router-link>
      </li>
      
      <li v-for="(item, index) in items" :key="index" class="breadcrumb-item">
        <span v-if="isLast(index)" class="active">{{ item.text }}</span>
        <router-link v-else :to="item.path">{{ item.text }}</router-link>
      </li>
    </template>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    items () {
      return this.$store.state.$breadcrumb
    }
  },
  methods: {
    isLast (index) {
      return index === this.items.length - 1
    }
  }
}
</script>
